var Handlebars = require("../../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=c5t5wnxp6mvabdrpn7wm4zt2zu/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "rotate-icon-right";
},"3":function(container,depth0,helpers,partials,data) {
    return "rotate-icon-down";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<i class=\"buddy-list-section-toggle zulip-icon zulip-icon-heading-triangle-right "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"is_collapsed"),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":81},"end":{"line":1,"column":149}}})) != null ? stack1 : "")
    + "\" aria-hidden=\"true\"></i>\n<h5 id=\""
    + alias3(alias2(alias1(depth0, "id", {"start":{"line":2,"column":10},"end":{"line":2,"column":12}} ), depth0))
    + "\" data-user-count=\""
    + alias3(alias2(alias1(depth0, "user_count", {"start":{"line":2,"column":35},"end":{"line":2,"column":45}} ), depth0))
    + "\" class=\"buddy-list-heading no-style hidden-for-spectators\">\n    <span class=\"buddy-list-heading-text\">"
    + alias3(alias2(alias1(depth0, "header_text", {"start":{"line":3,"column":44},"end":{"line":3,"column":55}} ), depth0))
    + "</span>\n    (<span class=\"buddy-list-heading-user-count\">"
    + alias3(alias2(alias1(depth0, "user_count", {"start":{"line":4,"column":51},"end":{"line":4,"column":61}} ), depth0))
    + "</span>)\n</h5>\n";
},"useData":true});